import useSWR from "swr";
import axios from "../../config/AxiosConfig";
import { TRANSACTIONS_API } from "../../store/actions/apiCollections";
import useSWRMutation from "swr/mutation";

const getTransactionsDataFetcher = (url) =>
  axios.get(url).then((response) => response?.data?.data);

export const useGetTransactions = (limit, filters = null) => {
  const buildQueryString = () => {
    const params = new URLSearchParams();
    params.append("limit", limit * 10);

    if (filters) {
      if (filters.campaign) params.append("campaign", filters.campaign);
      if (filters.investor) params.append("user", filters.investor);
      if (filters.minamount) params.append("minAmount", filters.minamount);
      if (filters.maxamount) params.append("maxAmount", filters.maxamount);
      if (filters.transaction)
        params.append("transaction", filters.transaction);
      if (filters.preapprovalStatus)
        params.append("preapprovalStatus", filters.preapprovalStatus);
      if (filters.byDays) params.append("byDays", filters.byDays);

      if (filters.startDate) {
        const startTimestamp = Math.floor(
          new Date(filters.startDate).getTime() / 1000
        );
        params.append("startDate", startTimestamp);
      }

      if (filters.endDate) {
        const endTimestamp = Math.floor(
          new Date(filters.endDate).getTime() / 1000
        );
        params.append("endDate", endTimestamp);
      }
    }

    return params.toString();
  };

  const queryString = buildQueryString();
  const apiUrl = `${TRANSACTIONS_API}?${queryString}`;

  const {
    data: transactionsData,
    isValidating,
    mutate,
  } = useSWR(apiUrl, getTransactionsDataFetcher, {
    keepPreviousData: true,
    revalidateOnFocus: !filters,
  });

  return { transactionsData, isValidating, mutate };
};

const updateTransactionFetcher = (url, { arg }) => {
  return axios.patch(`${url}${arg.tranId}`, arg).then((res) => res.data);
};

export const useUpdateTransaction = () => {
  const { data, trigger } = useSWRMutation(
    TRANSACTIONS_API,
    updateTransactionFetcher
  );

  return { data, trigger };
};
